var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.success)?_c('password-success',{on:{"close":function($event){return _vm.$emit('closeDialog')}}}):_c('password-form',{on:{"success":function($event){_vm.success=true},"close":function($event){return _vm.$emit('closeDialog')}}})}
var staticRenderFns = []

export { render, staticRenderFns }